import { _ as m } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import { QUERIES as r, BREAKPOINTS as u } from "@ucl/shared-component-foundations";
import { fordProIcons as O } from "@ucl/shared-icons";
import w, { useState as k, useEffect as P } from "react";
import i, { css as G } from "styled-components";
import "./es.object.keys-9d66766f.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as R } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { useWindowSize as T } from "./useWindowSize.js";
import { IconButton as j } from "./iconButton.js";
import { MediaDisclosureButton as N } from "./mediaDisclosureButton.js";
import { jsx as n, jsxs as I, Fragment as L } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./index-8b07dec9.js";
import "./button.js";
import "./combineRefs-c9ad2c39.js";
import "./index-5d0f31c6.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.parse-int-d7709701.js";
import "./string-trim-14e37ad3.js";
var D = ["children"], M = ["children"], F = ["children"], $ = ["shouldShowGradientOverlay", "coverImage", "onClick", "children", "playButtonSize", "disclosureLinks"], q = ["children"], K = O.PlayFilled, Q = "218px", J = "436px", X = "689px", Y = /* @__PURE__ */ i.div.withConfig({
  displayName: "blogVideo__Wrapper",
  componentId: "zhwum1-0"
})(["", ";display:", ";flex-direction:", ";max-width:", ";margin:", ";width:", ";"], function(e) {
  var o = e.theme.componentStyles;
  return G(o);
}, function(e) {
  return e.theme.components.blogVideo.Wrapper.display;
}, function(e) {
  return e.theme.components.blogVideo.Wrapper.flexDirection;
}, function(e) {
  return e.theme.components.blogVideo.Wrapper.maxWidth;
}, function(e) {
  return e.theme.components.blogVideo.Wrapper.margin;
}, function(e) {
  return e.theme.components.blogVideo.Wrapper.width;
}), Z = /* @__PURE__ */ i.div.withConfig({
  displayName: "blogVideo__HeadlineWrapper",
  componentId: "zhwum1-1"
})(["color:", ";font-size:", ";font-family:", ";font-weight:", ";line-height:", ";"], function(e) {
  return e.theme.components.blogVideo.HeadlineWrapper.color;
}, function(e) {
  return e.theme.components.blogVideo.HeadlineWrapper.fontSize;
}, function(e) {
  return e.theme.components.blogVideo.HeadlineWrapper.fontFamily;
}, function(e) {
  return e.theme.components.blogVideo.HeadlineWrapper.fontWeight;
}, function(e) {
  return e.theme.components.blogVideo.HeadlineWrapper.lineHeight;
}), ee = /* @__PURE__ */ i.div.withConfig({
  displayName: "blogVideo__SubheadlineWrapper",
  componentId: "zhwum1-2"
})(["margin-top:", ";color:", ";font-size:", ";font-family:", ";font-weight:", ";line-height:", ";@media ", "{margin-top:", ";}"], function(e) {
  return e.theme.components.blogVideo.SubheadlineWrapper.marginTop;
}, function(e) {
  return e.theme.components.blogVideo.SubheadlineWrapper.color;
}, function(e) {
  return e.theme.components.blogVideo.SubheadlineWrapper.fontSize;
}, function(e) {
  return e.theme.components.blogVideo.SubheadlineWrapper.fontFamily;
}, function(e) {
  return e.theme.components.blogVideo.SubheadlineWrapper.fontWeight;
}, function(e) {
  return e.theme.components.blogVideo.SubheadlineWrapper.lineHeight;
}, r.tabletAndUp, function(e) {
  return e.theme.components.blogVideo.SubheadlineWrapper.tabletAndUp.marginTop;
}), oe = /* @__PURE__ */ i.div.withConfig({
  displayName: "blogVideo__BodyWrapper",
  componentId: "zhwum1-3"
})(["margin-top:", ";color:", ";font-size:", ";font-family:", ";font-weight:", ";line-height:", ";"], function(e) {
  return e.theme.components.blogVideo.BodyWrapper.marginTop;
}, function(e) {
  return e.theme.components.blogVideo.BodyWrapper.color;
}, function(e) {
  return e.theme.components.blogVideo.BodyWrapper.fontSize;
}, function(e) {
  return e.theme.components.blogVideo.BodyWrapper.fontFamily;
}, function(e) {
  return e.theme.components.blogVideo.BodyWrapper.fontWeight;
}, function(e) {
  return e.theme.components.blogVideo.BodyWrapper.lineHeight;
}), te = /* @__PURE__ */ i.div.withConfig({
  displayName: "blogVideo__VideoContainerWrapper",
  componentId: "zhwum1-4"
})(["margin-top:", ";position:", ";background:", ";border-radius:", ";max-height:", ";min-height:", ";height:", ";iframe{border-radius:", ";}@media ", "{margin-top:", ";border-radius:", ";min-width:", ";height:", ";max-height:", ";iframe{border-radius:", ";}}@media ", "{height:", ";max-height:", ";}"], function(e) {
  return e.theme.components.blogVideo.VideoContainerWrapper.marginTop;
}, function(e) {
  return e.theme.components.blogVideo.VideoContainerWrapper.position;
}, function(e) {
  return e.theme.components.blogVideo.VideoContainerWrapper.background;
}, function(e) {
  return e.theme.components.blogVideo.VideoContainerWrapper.borderRadius;
}, function(e) {
  return e.theme.components.blogVideo.VideoContainerWrapper.maxHeight;
}, function(e) {
  return e.theme.components.blogVideo.VideoContainerWrapper.minHeight;
}, function(e) {
  return e.theme.components.blogVideo.VideoContainerWrapper.height;
}, function(e) {
  return e.theme.components.blogVideo.VideoContainerWrapper.iframe.borderRadius;
}, r.tabletAndUp, function(e) {
  return e.theme.components.blogVideo.VideoContainerWrapper.tabletAndUp.marginTop;
}, function(e) {
  return e.theme.components.blogVideo.VideoContainerWrapper.tabletAndUp.borderRadius;
}, function(e) {
  return e.theme.components.blogVideo.VideoContainerWrapper.tabletAndUp.minWidth;
}, function(e) {
  return e.theme.components.blogVideo.VideoContainerWrapper.tabletAndUp.height;
}, function(e) {
  return e.theme.components.blogVideo.VideoContainerWrapper.tabletAndUp.maxHeight;
}, function(e) {
  return e.theme.components.blogVideo.VideoContainerWrapper.tabletAndUp.iframe.borderRadius;
}, r.laptopAndUp, function(e) {
  return e.theme.components.blogVideo.VideoContainerWrapper.laptopAndUp.height;
}, function(e) {
  return e.theme.components.blogVideo.VideoContainerWrapper.laptopAndUp.maxHeight;
}), ne = /* @__PURE__ */ i.img.withConfig({
  displayName: "blogVideo__CoverImageElement",
  componentId: "zhwum1-5"
})(["background:", ";position:", ";border-radius:", ";cursor:", ";max-width:", ";width:", ";height:", ";object-fit:", ";@media ", "{border-radius:", ";height:", ";max-height:", ";}@media ", "{height:", ";max-height:", ";}"], function(e) {
  return e.theme.components.blogVideo.CoverImageElement.background;
}, function(e) {
  return e.theme.components.blogVideo.CoverImageElement.position;
}, function(e) {
  return e.theme.components.blogVideo.CoverImageElement.borderRadius;
}, function(e) {
  return e.theme.components.blogVideo.CoverImageElement.cursor;
}, function(e) {
  return e.theme.components.blogVideo.CoverImageElement.maxWidth;
}, function(e) {
  return e.theme.components.blogVideo.CoverImageElement.width;
}, function(e) {
  return e.theme.components.blogVideo.CoverImageElement.height;
}, function(e) {
  return e.theme.components.blogVideo.CoverImageElement.objectFit;
}, r.tabletAndUp, function(e) {
  return e.theme.components.blogVideo.CoverImageElement.tabletAndUp.borderRadius;
}, function(e) {
  return e.theme.components.blogVideo.CoverImageElement.tabletAndUp.height;
}, function(e) {
  return e.theme.components.blogVideo.CoverImageElement.tabletAndUp.maxHeight;
}, r.laptopAndUp, function(e) {
  return e.theme.components.blogVideo.CoverImageElement.laptopAndUp.height;
}, function(e) {
  return e.theme.components.blogVideo.CoverImageElement.laptopAndUp.maxHeight;
}), ie = /* @__PURE__ */ i(j).withConfig({
  displayName: "blogVideo__PlayButtonElement",
  componentId: "zhwum1-6"
})(["&&{position:", ";left:", ";bottom:", ";z-index:", ";@media ", "{left:", ";bottom:", ";}}"], function(e) {
  return e.theme.components.blogVideo.PlayButtonElement.position;
}, function(e) {
  return e.theme.components.blogVideo.PlayButtonElement.left;
}, function(e) {
  return e.theme.components.blogVideo.PlayButtonElement.bottom;
}, function(e) {
  return e.theme.components.blogVideo.PlayButtonElement.zIndex;
}, r.tabletAndUp, function(e) {
  return e.theme.components.blogVideo.PlayButtonElement.tabletAndUp.left;
}, function(e) {
  return e.theme.components.blogVideo.PlayButtonElement.tabletAndUp.bottom;
}), re = /* @__PURE__ */ i.div.withConfig({
  displayName: "blogVideo__GradientOverlay",
  componentId: "zhwum1-7"
})(["width:", ";height:", ";z-index:", ";position:", ";border-radius:", ";cursor:", ";background:", ";@media ", "{border-radius:", ";}"], function(e) {
  return e.theme.components.blogVideo.GradientOverlay.width;
}, function(e) {
  return e.theme.components.blogVideo.GradientOverlay.height;
}, function(e) {
  return e.theme.components.blogVideo.GradientOverlay.zIndex;
}, function(e) {
  return e.theme.components.blogVideo.GradientOverlay.position;
}, function(e) {
  return e.theme.components.blogVideo.GradientOverlay.borderRadius;
}, function(e) {
  return e.theme.components.blogVideo.GradientOverlay.cursor;
}, function(e) {
  return e.theme.components.blogVideo.GradientOverlay.background;
}, r.tabletAndUp, function(e) {
  return e.theme.components.blogVideo.GradientOverlay.tabletAndUp.borderRadius;
});
function pe(e) {
  var o = e.children, t = m(e, D);
  return /* @__PURE__ */ n(Z, Object.assign({}, t, {
    children: o
  }));
}
function me(e) {
  var o = e.children, t = m(e, M);
  return /* @__PURE__ */ n(ee, Object.assign({}, t, {
    children: o
  }));
}
function ae(e) {
  var o = e.children, t = m(e, F);
  return /* @__PURE__ */ n(oe, Object.assign({}, t, {
    children: o
  }));
}
function de(e) {
  var o, t = e.shouldShowGradientOverlay, x = t === void 0 ? !0 : t, c = e.coverImage, h = e.onClick, S = e.children, s = e.playButtonSize, B = s === void 0 ? "medium" : s, g = e.disclosureLinks, b = m(e, $), E = R({
    label: "BlogVideo"
  }), f = w.useState(!!c), V = f[0], A = f[1], v = w.useState(!0), H = v[0], U = v[1], W = {
    right: ["108px", "108px", "20px"],
    bottom: ["25px", "14px", "8px"]
  };
  function d(z) {
    h == null || h(z), A(!1), U(!1);
  }
  var y = k(0), C = y[0], l = y[1], _ = T(), a = _.width;
  return P(function() {
    a > u.laptopMin ? l(0) : a < u.laptopMin && a > u.tabletMin ? l(1) : l(2);
  }, [a]), /* @__PURE__ */ I(te, Object.assign({}, b, E, {
    children: [V && /* @__PURE__ */ I(L, {
      children: [/* @__PURE__ */ n(ie, {
        "aria-label": (o = b["aria-label"]) != null ? o : "Play",
        icon: /* @__PURE__ */ n(K, {
          "aria-hidden": !0
        }),
        onClick: d,
        size: B
      }), x && /* @__PURE__ */ n(re, {
        "aria-hidden": "true",
        onClick: d
      }), /* @__PURE__ */ n(ne, {
        "aria-hidden": "true",
        src: c,
        onClick: d
      })]
    }), g && H && /* @__PURE__ */ n(N, Object.assign({}, g, {
      style: {
        bottom: W.bottom[C],
        right: W.right[C]
      }
    })), /* @__PURE__ */ n("div", {
      "aria-hidden": V ? "true" : "false",
      children: S
    })]
  }));
}
function p(e) {
  var o = e.children, t = m(e, q);
  return /* @__PURE__ */ n(Y, Object.assign({}, t, {
    children: o
  }));
}
p.Headline = pe;
p.Subheadline = me;
p.Body = ae;
p.VideoContainer = de;
p.mobileHeight = Q;
p.tabletHeight = J;
p.laptopAndUpHeight = X;
export {
  p as BlogVideo
};
